const mutations = {
  /**
   * Set the purchases property on state
   * with purchases parameter.
   *
   * @param state
   * @param purchases
   */
  setPurchases(state, purchases) {
    state.purchases = purchases;
  },

  /**
   * Set the uses property on state
   * with uses parameter.
   *
   * @param state
   * @param uses
   */
  setUses(state, uses) {
    state.uses = uses;
  },
};

export default mutations;
